import {StudentSectionMode} from '../types';

export const sectionTitleByMode: Record<StudentSectionMode, string> = {
	[StudentSectionMode.View]: 'Students',
	[StudentSectionMode.Edit]: 'Edit Mode',
	[StudentSectionMode.Rearrange]: 'Rearrange Mode',
	[StudentSectionMode.Add]: 'Add Mode',
};
